import EmailTemplate from ".";

export const emailTemplateRoutes = () => [
  {
    path: "/admin/email-template",
    title: "email-template",
    layout: "admin",
    routeType: "admin",
    component: EmailTemplate,
  },
];
